import styled from "styled-components";

export const Container = styled.div`
  height: auto;
  width: 100%;
  background: ${(props) => props.theme.background.default};
  display: flex;
  /* align-items: center; */
  justify-content: center;

  .img-modified {
    padding: 0 25px;
  }
  .img-modified2 {
    padding: 0 40px;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 100px 0 240px;
  background: ${(props) => props.theme.background.default};
  @media (max-width: 1024px) {
    padding: 100px 0 100px;
  }
`;

export const TextTitle = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 0 auto;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 150%;
  text-transform: uppercase;
  color: ${(props) => props.theme.color.default};
  @media (max-width: 1600px) {
    padding: 0 25px;
  }
`;

export const PatnersList = styled.div`
  margin-top: 80px;
  flex-direction: column;
  overflow: hidden;
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin-top: 40px;
    padding: 0 9px;
  }
  @media (max-width: 450px) {
    margin-top: 30px;
  }
`;

export const PatnersImg = styled.div`
  /* width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  cursor: grab;
  padding: 20px;
  @media (max-width: 768px) {
    overflow: none;
    white-space: normal;
    padding: 0;
  } */
  img {
    border-radius: 50%;
    background-color: #ffffff;
    margin: 24px;
    object-fit: contain;
    width: calc(33.33% - 32px);
    margin: 16px;
    /* min-height: 218px; */

    @media (max-width: 540px) {
      /* height: 130px; */
      width: calc(33.33% - 20px);
      margin: 10px;
    }
    @media (max-width: 450px) {
      /* height: 110px; */
      width: calc(33.33% - 15px);
      margin: 7.5px;
    }
  }
`;

export const SliderBox = styled.div`
  margin: 120px auto 0;
  @media (max-width: 1024px) {
    margin: 60px auto 0;
  }
  @media (max-width: 768px) {
    display: none;
  }

  .slick-slide {
    padding: 10px;
    text-align: center;
  }
  img {
    background-color: #ffffff;
    border-radius: 50%;
    object-fit: contain;
    max-width: 350px;
    margin: 0 20px;
    /* min-height: 350px; */
  }
`;
